module.exports = __webpack_public_path__ + "static/img/S-303-MDF.9cd6488.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/S-303-MDF.png
// module id = FI5K
// module chunks = 0